@if (
  {
    customer: customer$ | async,
    isCustomer: isCustomerPresent$ | async,
  };
  as data
) {
  <button
    mat-button
    [matMenuTriggerFor]="userMenu"
    title="{{
      data.isCustomer
        ? ('Hello! Log out' | translate | async)
        : ('Hello! Log in' | translate | async)
    }}"
  >
    <mat-icon svgIcon="account-outline"></mat-icon>
    @if (!data.isCustomer) {
      <span class="text" translate>Hello! Log in</span>
    }
    @if (data.isCustomer) {
      <span class="text" translate>Hello! Log out</span>
    }
  </button>
  <mat-menu #userMenu="matMenu" class="user-dropdown">
    @if (!data.isCustomer) {
      <a mat-menu-item sRouterLink="auth/login" (click)="toggleMenu()" translate>
        Login
      </a>
      <a mat-menu-item sRouterLink="auth/register" (click)="toggleMenu()" translate>
        Register
      </a>
    }
    @if (data.isCustomer && data.customer) {
      <span class="user-dropdown__header">
        <span translate>Logged in as</span>
        <b>{{ data.customer.firstname }} {{ data.customer.lastname }}</b>
      </span>
      <a mat-menu-item sRouterLink="customer" (click)="toggleMenu()" translate
        >Customer Dashboard</a
      >
      <button mat-menu-item (click)="logout()" (click)="toggleMenu()" translate>
        Logout
      </button>
    }
  </mat-menu>
}
